<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1 11C1 5.4725 5.47301 1 11 1C16.5275 1 21 5.47301 21 11C21 16.5275 16.527 21 11 21C5.4725 21 1 16.5269 1 11ZM2.39535 11C2.39535 15.7446 6.25539 19.6046 11 19.6046C15.7446 19.6046 19.6046 15.7446 19.6046 11C19.6046 6.25535 15.7446 2.39535 11 2.39535C6.25539 2.39535 2.39535 6.25535 2.39535 11Z"
      fill="currentColor"
    />
    <path
      d="M11 0.85C5.39017 0.85 0.85 5.38965 0.85 11H1.15C1.15 5.55535 5.55585 1.15 11 1.15V0.85ZM21.15 11C21.15 5.39017 16.6103 0.85 11 0.85V1.15C16.4447 1.15 20.85 5.55585 20.85 11H21.15ZM11 21.15C16.6098 21.15 21.15 16.6103 21.15 11H20.85C20.85 16.4447 16.4442 20.85 11 20.85V21.15ZM0.85 11C0.85 16.6098 5.38965 21.15 11 21.15V20.85C5.55535 20.85 1.15 16.4441 1.15 11H0.85ZM11 19.4546C6.33823 19.4546 2.54535 15.6618 2.54535 11H2.24535C2.24535 15.8275 6.17255 19.7546 11 19.7546V19.4546ZM19.4546 11C19.4546 15.6618 15.6618 19.4546 11 19.4546V19.7546C15.8275 19.7546 19.7546 15.8275 19.7546 11H19.4546ZM11 2.54535C15.6618 2.54535 19.4546 6.33819 19.4546 11H19.7546C19.7546 6.17251 15.8275 2.24535 11 2.24535V2.54535ZM2.54535 11C2.54535 6.33819 6.33823 2.54535 11 2.54535V2.24535C6.17255 2.24535 2.24535 6.17251 2.24535 11H2.54535Z"
      fill="currentColor"
    />
    <path
      d="M10.7041 13.6533C10.1513 13.6533 9.70374 14.114 9.70374 14.6668C9.70374 15.2065 10.1381 15.6804 10.7041 15.6804C11.2701 15.6804 11.7176 15.2065 11.7176 14.6668C11.7176 14.114 11.2569 13.6533 10.7041 13.6533Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="0.3"
    />
    <path
      d="M10.8752 5.97925C9.09814 5.97925 8.28204 7.03233 8.28204 7.74312C8.28204 8.25647 8.71642 8.49343 9.07181 8.49343C9.78263 8.49343 9.49306 7.47983 10.8357 7.47983C11.4938 7.47983 12.0204 7.76944 12.0204 8.37495C12.0204 9.08573 11.2832 9.49378 10.8488 9.86233C10.4671 10.1914 9.96693 10.7311 9.96693 11.8631C9.96693 12.5476 10.1512 12.745 10.6909 12.745C11.3358 12.745 11.4675 12.4555 11.4675 12.2053C11.4675 11.5208 11.4806 11.126 12.2046 10.56C12.56 10.2835 13.6788 9.38843 13.6788 8.15112C13.6788 6.91382 12.56 5.97925 10.8752 5.97925Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="0.3"
    />
  </svg>
</template>
